import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=330b9ad7&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=330b9ad7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330b9ad7",
  null
  
)

export default component.exports